import { SaasApiClient } from '@fourthwall/services/dist/SaasApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useDefaultSubscriptionPlanQuery = createQueryHook(
  SaasApiClient.getDefaultSubscriptionPlan,
  {
    queryKey: ['defaultSubscriptionPlan'],
  },
)
